import { PillLink } from "@/components/site/Buttons";

export default function NotFound() {
  return (
    <section className="shell flex min-h-[80vh] flex-col justify-center pb-24 pt-40" data-testid="not-found-page">
      <p className="eyebrow text-fg-3">404 · Off chart</p>
      <h1 className="mt-6 text-6xl font-[560] leading-[0.95] tracking-[-0.05em] text-fg sm:text-8xl">Nothing charted here.</h1>
      <p className="mt-6 max-w-lg text-lg text-fg-2">The page you're looking for doesn't exist, or has moved.</p>
      <div className="mt-10"><PillLink to="/" testId="not-found-home">Back to the mission</PillLink></div>
    </section>
  );
}
